import React, { useState } from 'react';
import { Modal, Divider } from 'antd';
import { LoginForm } from '../../LoginForm';
import { QuoteProps } from '@partsbadger/types';
import VerifyUser from './VerifyUser';

interface ILoginOrRegisterModalProps {
    open: boolean;
    onClose: () => void;
    onSuccess: (quote_uid?: string) => void;
    first_name?: string;
    last_name?: string;
    email?: string;
    company?: string;
    onResendVerification: () => void;
}

const LoginOrRegisterModal: React.FC<ILoginOrRegisterModalProps> = ({
    open,
    onClose,
    first_name,
    last_name,
    email,
    company,
    onSuccess,
    onResendVerification,
}) => {
    const [showVerifyUser, setShowVerifyUser] = useState(false);
    const [rapidQuoteUid, setRapidQuoteUid] = useState<string | null>(null);

    return (
        <Modal
            open={open}
            onCancel={onClose}
            closable={showVerifyUser}
            width={600}
            footer={null}
            title={'Please Login or Register to Continue'}
        >
            <div className={'w-full flex flex-col mt-2'}>
                {showVerifyUser ? (
                    <VerifyUser
                        onResendVerification={() => onResendVerification()}
                        onSuccess={() => onSuccess(rapidQuoteUid || undefined)}
                    />
                ) : (
                    <>
                        <LoginForm
                            first_name={first_name}
                            last_name={last_name}
                            email={email}
                            company={company}
                            handleLogin={payload => {
                                if (payload?.quoteData) {
                                    setRapidQuoteUid(payload.quoteData.quote_uid);
                                }

                                if (!payload?.userData?.is_verified_email) {
                                    setShowVerifyUser(true);
                                    return;
                                }

                                onSuccess(payload?.quoteData?.quote_uid || undefined);
                                // history.push('/my-account/' + '');
                            }}
                            bordered={false}
                            onClose={onClose}
                        />
                    </>
                )}
            </div>
        </Modal>
    );
};

export default LoginOrRegisterModal;
